
const digest = 'cdfe653aae3d5c7fefaa0687135092f4da2f1a45e975db2f4db09ee6bdfcf755';
const classes = {"button":"_button_7fhng_1","wrapper":"_wrapper_7fhng_17"};
const css = `._button_7fhng_1 {
  font-family: "Rubik", sans-serif;
  border-left: 4px solid #1665d8;
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  padding: 24px;
  border-top: 1px solid #eaedf3;
  border-bottom: 1px solid #eaedf3;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #000000;
}

._wrapper_7fhng_17 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 15px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  